import BGPH1 from "../../assets/images/backgrounds/AboutUs1.png";
import { Helmet } from "react-helmet";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const Disclaimer = () => {
  const location = useLocation();
  const path = location.pathname;
  return (
    <>
      <Helmet>
        <title>Disclaimer - Addon Broker</title>
        <meta charset="UTF-8" />
        <meta
          name="description"
          content="Disclaimer - The information provided on Addon Brokers website is general in nature and does not constitute financial advice."
        />
        <link rel="canonical" href={path} />
      </Helmet>

      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content"></div>
      </div>

      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundColor: "#005257" }}
        ></div>
        <div className="container">
          <ul className="thm-breadcrumb list-unstyled">
            {/* <li><Link to="/">Home</Link></li> */}
            <li>
              <span>Disclaimer</span>
            </li>
          </ul>
          <h2>Disclaimer</h2>
        </div>
      </section>

      <section className="about-two pt-120 pb-120">
        <div className="container" >
          <div className="row">
            <div className="col-lg-12">
              <div className="about-two__content" >
                <p className="about-two__text"  style={{ marginTop: "-40px", textAlign: "justify"}}>
                  The information provided on this website is general in nature
                  and does not constitute financial or credit advice.
                </p>

                <div className="block-title text-left mt-50">
                  <h3 className="block-title__title" style={{ fontSize: "30px", textAlign: "justify" }}>Key Points</h3>
                </div>

                <ul className="list-unstyled ml-0 about-two__list">
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>We do not
                    guarantee that the information is complete, accurate, or
                    suitable for your circumstances.
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Mortgage
                    products and lending criteria vary and may change without
                    notice.
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>You should not
                    rely solely on this website to make financial decisions.
                  </li>
                  <li>
                    <i className="fa fa-arrow-circle-right"></i>Always seek
                    independent legal, financial, and taxation advice before
                    acting.
                  </li>
                </ul>

                <p className="about-two__text" style={{ marginTop: "20px", textAlign: "justify" }}>
                  Addon Brokers, its directors, and employees accept no
                  liability for any loss or damage suffered as a result of
                  reliance on information on this website.
                </p>

                <p className="about-two__text" style={{ marginTop: "20px", textAlign: "justify" }}>
                  All applications are subject to lender assessment and approval
                  criteria. Fees, charges, and eligibility requirements may
                  apply.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Disclaimer;
